import { KnownProjectDtoProjectType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryGetProject } from '../core/queries/projects.queries';

export type EntityLabel = {
  singular: string;
  plural: string;
};

export function useProjectLabels(projectID?: string): EntityLabel {
  const project = useQueryGetProject(projectID);

  switch (project.data?.projectType) {
    case KnownProjectDtoProjectType.CommercialBuilding:
    case KnownProjectDtoProjectType.Business:
    case KnownProjectDtoProjectType.ResidentialBuilding:
      return {
        singular: 'Building',
        plural: 'Buildings'
      };
    case KnownProjectDtoProjectType.Retailer:
    case KnownProjectDtoProjectType.Store:
      return {
        singular: 'Store',
        plural: 'Stores'
      };
    case KnownProjectDtoProjectType.Carrier:
      return {
        singular: 'Carrier',
        plural: 'Carriers'
      };
    case KnownProjectDtoProjectType.Region:
      return {
        singular: 'Region',
        plural: 'Regions'
      };
    default:
      return {
        singular: 'Project',
        plural: 'Projects'
      };
  }
}

export function useUserLabels(projectID?: string): EntityLabel {
  const project = useQueryGetProject(projectID);

  switch (project.data?.projectType) {
    case KnownProjectDtoProjectType.CommercialBuilding:
    case KnownProjectDtoProjectType.Retailer:
    case KnownProjectDtoProjectType.Store:
      return {
        singular: 'Customer',
        plural: 'Customers'
      };
    case KnownProjectDtoProjectType.Project:
    case KnownProjectDtoProjectType.Precinct:
    case KnownProjectDtoProjectType.ResidentialBuilding:
      return {
        singular: 'Occupant',
        plural: 'Occupants'
      };
    // Carriers and regions manage couriers rather than customers or occupants
    case KnownProjectDtoProjectType.Carrier:
    case KnownProjectDtoProjectType.Region:
      return {
        singular: 'Courier',
        plural: 'Couriers'
      };
    default:
      return {
        singular: 'User',
        plural: 'Users'
      };
  }
}

export function useGroupLabels(projectID: string): EntityLabel {
  const project = useQueryGetProject(projectID);

  switch (project.data?.projectType) {
    case KnownProjectDtoProjectType.ResidentialBuilding:
      return {
        singular: 'Unit',
        plural: 'Units'
      };
    case KnownProjectDtoProjectType.CommercialBuilding:
      return {
        singular: 'Tenant',
        plural: 'Tenants'
      };
    case KnownProjectDtoProjectType.Business:
      return {
        singular: 'Department',
        plural: 'Departments'
      };
    default:
      return {
        singular: 'Group',
        plural: 'Groups'
      };
  }
}
